import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../utils/axiosInstance';
import { dashboardApi, getAuthHeaders } from '../config/api';

const filterToParam = {
  'This Week': 'week',
  'This Month': 'month',
  'This Year': 'year',
};

export const fetchDashboardOverview = createAsyncThunk(
  'dashboard/fetchOverview',
  async (activeFilter, { rejectWithValue, getState }) => {
    try {
      const response = await axios.get(dashboardApi('overview'), {
        params: { timeRange: filterToParam[activeFilter] ?? 'month' },
        headers: getAuthHeaders(getState, { includeApiKey: true }),
      });
      return { data: response.data, activeFilter };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message ?? 'Failed to load dashboard');
    }
  },
);

const initialState = {
  activeFilter: 'This Year',
  stats: null,
  budgetAnalysis: null,
  spendTrend: null,
  spendByCategory: null,
  transactions: [],
  loading: false,
  error: null,
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setActiveFilter(state, action) {
      state.activeFilter = action.payload;
    },
    clearError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardOverview.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDashboardOverview.fulfilled, (state, action) => {
        state.loading = false;
        const { data, activeFilter } = action.payload;
        state.activeFilter = activeFilter;
        state.stats = data.stats;
        state.budgetAnalysis = data.budgetAnalysis;
        state.spendTrend = data.spendTrend;
        state.spendByCategory = data.spendByCategory;
        state.transactions = data.transactions || [];
      })
      .addCase(fetchDashboardOverview.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setActiveFilter, clearError } = dashboardSlice.actions;
export default dashboardSlice.reducer;

export const selectDashboardLoading = (s) => s.dashboard.loading;
export const selectDashboardError = (s) => s.dashboard.error;
export const selectActiveFilter = (s) => s.dashboard.activeFilter;
export const selectStats = (s) => s.dashboard.stats;
export const selectBudgetAnalysis = (s) => s.dashboard.budgetAnalysis;
export const selectSpendTrend = (s) => s.dashboard.spendTrend;
export const selectSpendByCategory = (s) => s.dashboard.spendByCategory;
export const selectTransactions = (s) => s.dashboard.transactions;
